"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkPhone = checkPhone;
exports.checkPhoneSucceed = exports.checkPhoneLoading = exports.checkPhoneFailed = void 0;
var _isPhoneRegistered = require("../../api/isPhoneRegistered");
var _actionGenerator = require("../../types/redux/actionGenerator");
var _types = require("./types");
var _view = require("../../types/view");
var _flow = require("../../types/flow");
var _events = require("../../types/events");
var _flow2 = require("../flow");
var _view2 = require("../view");
var _sendCode = require("./sendCode");
var _validation = require("../../utils/validation");
var _constants = require("./constants");
const checkPhoneLoading = exports.checkPhoneLoading = (0, _actionGenerator.actionGenerator)(_types.ECheckPhoneActionTypes.Loading);
const checkPhoneFailed = exports.checkPhoneFailed = (0, _actionGenerator.actionGenerator)(_types.ECheckPhoneActionTypes.Failed);
const checkPhoneSucceed = exports.checkPhoneSucceed = (0, _actionGenerator.actionGenerator)(_types.ECheckPhoneActionTypes.Succeed);
function checkPhone() {
  return async (dispatch, getState, context) => {
    const {
      phoneAuth: {
        phone
      },
      view
    } = getState();
    const isPhoneInvalid = !(0, _validation.isValidPhone)(phone);
    if (isPhoneInvalid) {
      dispatch(checkPhoneFailed(_constants.INCORRECT_PHONE_ERROR_MESSAGE));
      return;
    }
    dispatch(checkPhoneLoading());
    const response = await (0, _isPhoneRegistered.isPhoneRegistered)(context, {
      phone
    });
    if (response.status === _isPhoneRegistered.ECheckPhoneStatus.Succeed) {
      const {
        isRegistered
      } = response;
      dispatch(checkPhoneSucceed({
        isRegistered
      }));
      context.emitter.emit(_events.EEventType.PhoneChecked, {
        isRegistered
      });
      if (isRegistered) {
        dispatch((0, _sendCode.sendCode)());
      } else {
        dispatch((0, _view2.changeView)(_view.EActiveView.Agreement, {
          prevView: view.active,
          prevData: view.data,
          phone
        }));
        dispatch((0, _flow2.changeFlow)(_flow.EActiveFlow.Registration));
      }
      return;
    }
    dispatch(checkPhoneFailed(response.message));
  };
}